import request from "utils/request";
import store from "@/store";
//所有列表走这个接口，所以参数传到data里，name:TableId,通用参数params
export async function getData(data) {
  var queryParams = {
    TableId: data.name,
    SortName: data.sortName,
    SortType: data.sortType
  };
  // console.log(111, store.state.school.schoolData);
  // console.log(222, window.location.href);
  //添加学校查询参数
  if (window.location.href.includes("/portal")) {
    if (store.state.school.schoolData) {
      queryParams.School = store.state.school.schoolData.sid;
    } else {
      console.error("域名未绑定！");
      return;
    }
  }
  if (data.params) {
    queryParams.queryStr = JSON.stringify(data.params);
  }
  var response = "";
  //取前N条需要传top
  if (data.top) {
    queryParams.PageSize = data.top;
    response = await request({
      url: "/ContentData/GetTopList",
      method: "get",
      params: queryParams
    });
  }
  //分页index,size
  else if (data.index) {
    queryParams.PageIndex = data.index;
    if (data.size) {
      queryParams.PageSize = data.size;
    }
    response = await request({
      url: "/ContentData/GetPageList",
      method: "get",
      params: queryParams
    });
  }
  //所有数据
  else {
    response = await request({
      url: "/ContentData/GetAllList",
      method: "get",
      params: queryParams
    });
  }
  return response.Result;
}

export async function getDetail(data) {
  var queryParams = { tableId: data.name, id: data.id };
  var response = await request({
    url: "/ContentData/Get",
    method: "get",
    params: queryParams
  });
  return response.Result;
}

export async function getCurrentAndAdjacent(data) {
  var queryParams = { tableId: data.name, id: data.id, college: data.college };
  var response = await request({
    url: "/ContentData/GetCurrentAndAdjacent",
    method: "get",
    params: queryParams
  });
  return response.Result;
}
